
import Vue from "vue";
import { NewBoxesApiFunc, NewSensorsApiFunc, setAccessToken } from "@/api";
import { Sensor, Box } from "@/models";

import TheTemplate from "../../TheNoSidebarTemplate.vue";
import ToiletBoxEditor from "./components/ToiletBoxEditor.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";

export type DataType = {
  box?: Box;
  sensors: Array<Sensor>;
};

export default Vue.extend({
  name: "ToiletBoxDetailScreen",

  components: {
    TheTemplate,
    ToiletBoxEditor,
    BaseCloseButton,
  },

  data(): DataType {
    return {
      box: undefined,
      sensors: [],
    };
  },

  mounted(): void {
    this.getBox();
    this.fetchSensors();
  },

  methods: {
    async fetchSensors(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      // TODO: 個室とまだ紐付いていないものだけにする必要がある？
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewSensorsApiFunc().listSensors(
        companyId,
        undefined,
        undefined,
        false
      );

      if (err != null) return this.$handleApiError(err, this.fetchSensors);

      this.sensors = data.list;
    },

    async getBox(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const toiletId = this.$router.currentRoute.params.toiletId;
      const boxId = this.$router.currentRoute.params.boxId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewBoxesApiFunc().getBox(
        companyId,
        toiletId,
        boxId
      );

      if (err != null) return this.$handleApiError(err, this.getBox);

      this.box = data;
    },

    async updateBox(box: Box): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);

      const toiletId = this.$router.currentRoute.params.toiletId;
      const boxId = this.$router.currentRoute.params.boxId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewBoxesApiFunc().updateBox(
        companyId,
        toiletId,
        boxId,
        box
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.updateBox(box);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: `company-toilet-boxes`,
          params: {
            updated: "true",
            toiletId: toiletId,
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
